import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import Portfolio from '../components/Portfolio/Portfolio';
import './PageStyles.css';

const PortfolioPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page-wrapper">
      <motion.div 
        className="page-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            {t('portfolio.title')}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            {t('portfolio.subtitle')}
          </motion.p>
        </div>
      </motion.div>
      <Portfolio />
    </div>
  );
};

export default PortfolioPage;
